import { create } from 'zustand';

interface CurrentPageState {
  /**
   * The name of what is open, for the few screens whose name the menu cannot supply: a
   * dashboard someone built, and a person or store found by search, are known only by an
   * id in their address. Null everywhere else.
   */
  title: string | null;
  setTitle: (title: string | null) => void;
}

// The page that knows the name sets it; the shell reads it for the trail and the
// browser tab. Whoever sets a title clears it (null) when it leaves, so one screen's
// name is never drawn over another.
export const useCurrentPageStore = create<CurrentPageState>()((set) => ({
  title: null,
  setTitle: (title) => set({ title }),
}));
